
/**
 * WELDING TABLE CONFIGURATOR — DATA MODEL
 * ----------------------------------------------------------------
 * Hole System = filter only
 * Thickness   = filter only
 * Product + Size = individual table price
 *
 * LEG LOGIC:
 * <= 2500mm longest dimension = 4 legs
 * > 2500mm longest dimension  = 6 legs
 *
 * SKU FORMAT:
 * [PRODUCT]-[LENGTH]-[WIDTH]-[HOLE SYSTEM]-[BUILD][LEG OPTION]
 * Example: PR6-2000-1250-16D-RMLC
 * ----------------------------------------------------------------
 */
window.WELDING_CONFIGURATOR_DATA = {
  holeSystems: [
    { id: "16D", label: "16D", icon: "16d.png", enabled: true },
    { id: "28D", label: "28D", icon: "28d.png", enabled: true }
  ],

  thicknessIcons: {
    6: "6mm.png",
    8: "8mm.png",
    10: "10mm.png",
    15: "15mm.png"
  },

  sizeIcons: {
    "1200 x 800mm": "size-1200x800.png",
    "1500 x 1000mm": "size-1500x1000.png",
    "2000 x 1000mm": "size-2000x1000.png",
    "2400 x 1200mm": "size-2400x1200.png",
    "3000 x 1500mm": "size-3000x1500.png"
  },

  legIcons: {
    "No Legs": "without-legs.png",
    "Standard Legs": "with-legs.png",
    "Height Adjustable Legs": "with-adjustlegs.png"
  },

  feetIcons: {
    "Adjustable Feet": "adjustable-feet.png",
    "FM Castors": "casters.png",
    "Standard Castors": "casters2.png"
  },

  buildIcons: {
    "Self Weld Kit": "self-weld-kit.png",
    "Ready Made by Mac": "ready-made.png"
  },

  legColorIcons: {},

  // SKU product prefixes
  skuPrefixes: {
    basic_16d: "BAS",
    hobby_16d: "HOB",
    midipro_16d: "MIDP",
    pro6_16d: "PR6",
    pro8_16d: "PR8",
    pro10_16d: "PR10",
    ultra10_16d: "UL10",
    ultra15_16d: "UL15",
    pro10_28d: "PR10",
    ultra10_28d: "UL10",
    ultra15_28d: "UL15"
  },

  // =========================================================
  // SHOPIFY VARIANT IDS — EDIT THIS SECTION
  // =========================================================
  // Paste the Shopify variant ID beside each table size.
  // These IDs are the ones supplied in your latest master code.
  // =========================================================
  shopifyVariantIds: {
    basic_16d: {
      "520 x 520mm": "58429842653567",
      "1000 x 600mm": "58429842653567"
    },
    hobby_16d: {
      "1200 x 600mm": "58392977277311",
      "1200 x 800mm": "58392977277311"
    },
    midipro_16d: {
      "1000 x 1000mm": "58392977277311",
      "1250 x 750mm": "58392977277311",
      "1250 x 1000mm": "58392977277311",
      "1250 x 1250mm": "58392977277311",
      "1500 x 750mm": "58393049596287",
      "1500 x 1000mm": "58393049596287",
      "1500 x 1250mm": "58393049596287",
      "1500 x 1500mm": "58393040191871",
      "1750 x 750mm": "58392954438015",
      "1750 x 1000mm": "58392954438015",
      "1750 x 1250mm": "58392954438015",
      "1750 x 1500mm": "58393040191871",
      "1800 x 900mm": "58392954438015",
      "2000 x 1000mm": "58392954438015"
    },
    pro6_16d: {
      "1000 x 1000mm": "58392977277311",
      "1250 x 750mm": "58392977277311",
      "1250 x 1000mm": "58392977277311",
      "1250 x 1250mm": "58392977277311",
      "1500 x 750mm": "58393049596287",
      "1500 x 1000mm": "58393049596287",
      "1500 x 1250mm": "58393049596287",
      "1500 x 1500mm": "58393040191871",
      "1750 x 750mm": "58392954438015",
      "1750 x 1000mm": "58392954438015",
      "1750 x 1250mm": "58392954438015",
      "1750 x 1500mm": "58393040191871",
      "1800 x 900mm": "58392954438015",
      "2000 x 1000mm": "58392954438015",
      "2000 x 1250mm": "58392954438015",
      "2500 x 1000mm": "58393040191871",
      "2500 x 1250mm": "58393040191871",
      "2900 x 1400mm": "58393041273215"
    },
    pro8_16d: {
      "1000 x 1000mm": "58392977277311",
      "1250 x 750mm": "58392977277311",
      "1250 x 1000mm": "58392977277311",
      "1250 x 1250mm": "58392977277311",
      "1500 x 750mm": "58393049596287",
      "1500 x 1000mm": "58393049596287",
      "1500 x 1250mm": "58393049596287",
      "1500 x 1500mm": "58393040191871",
      "1750 x 750mm": "58393040191871",
      "1750 x 1000mm": "58392954438015",
      "1750 x 1250mm": "58392954438015",
      "1750 x 1500mm": "58393040191871",
      "1800 x 900mm": "58392954438015",
      "2000 x 1000mm": "58392954438015",
      "2000 x 1250mm": "58392954438015",
      "2500 x 1000mm": "58393040191871",
      "2500 x 1250mm": "58393041273215",
      "2900 x 1400mm": "58393041273215"
    },
    pro10_16d: {
      "1000 x 1000mm": "58392977277311",
      "1250 x 750mm": "58392977277311",
      "1250 x 1000mm": "58392977277311",
      "1250 x 1250mm": "58392977277311",
      "1500 x 750mm": "58393049596287",
      "1500 x 1000mm": "58393049596287",
      "1500 x 1250mm": "58393049596287",
      "1500 x 1500mm": "58393040191871",
      "1750 x 750mm": "58392954438015",
      "1750 x 1000mm": "58392954438015",
      "1750 x 1250mm": "58392954438015",
      "1750 x 1500mm": "58393040191871",
      "1800 x 900mm": "58392954438015",
      "2000 x 1000mm": "58392954438015",
      "2000 x 1250mm": "58393040191871",
      "2500 x 1000mm": "58393040191871",
      "2500 x 1250mm": "58393041273215",
      "2900 x 1400mm": "58393041273215"
    },
    ultra10_16d: {
      "1400 x 1000mm": "58393049596287",
      "1400 x 1400mm": "58393040191871",
      "1800 x 1400mm": "58393040191871",
      "2200 x 1400mm": "58393040191871",
      "2800 x 1400mm": "58393041273215",
      "3000 x 1500mm": "58393041273215"
    },
    ultra15_16d: {
      "1400 x 1000mm": "58393049596287",
      "1400 x 1400mm": "58393040191871",
      "1800 x 1400mm": "58393040191871",
      "2200 x 1400mm": "58393040191871",
      "2800 x 1450mm": "58393041273215",
      "3000 x 1500mm": "58393041273215"
    },
    pro10_28d: {
      "1000 x 1000mm": "58392977277311",
      "1250 x 750mm": "58392977277311",
      "1250 x 1000mm": "58392977277311",
      "1250 x 1250mm": "58392977277311",
      "1500 x 750mm": "58393049596287",
      "1500 x 1000mm": "58393049596287",
      "1500 x 1250mm": "58393049596287",
      "1500 x 1500mm": "58393040191871",
      "1750 x 750mm": "58392954438015",
      "1750 x 1000mm": "58392954438015",
      "1750 x 1250mm": "58392954438015",
      "1750 x 1500mm": "58393040191871",
      "1800 x 900mm": "58392954438015",
      "2000 x 1000mm": "58392954438015",
      "2000 x 1250mm": "58393040191871",
      "2500 x 1000mm": "58393040191871",
      "2500 x 1250mm": "58393041273215",
      "2900 x 1400mm": "58393041273215"
    },
    ultra10_28d: {
      "1400 x 1000mm": "58393049596287",
      "1400 x 1400mm": "58393040191871",
      "1800 x 1400mm": "58393040191871",
      "2200 x 1400mm": "58393040191871",
      "2800 x 1400mm": "58393041273215",
      "3000 x 1500mm": "58393041273215"
    },
    ultra15_28d: {
      "1400 x 1000mm": "58393049596287",
      "1400 x 1400mm": "58393040191871",
      "1800 x 1400mm": "58393040191871",
      "2200 x 1400mm": "58393040191871",
      "2800 x 1450mm": "58393041273215",
      "3000 x 1500mm": "58393041273215"
    }
  },

  // =========================================================
  // PRODUCT PDF DRAWINGS
  // =========================================================
  // Paste the full Shopify Content > Files PDF URL into drawingPdf.
  // The Download PDF button uses ONLY the selected table type.
  // Example:
  // drawingPdf: "https://cdn.shopify.com/s/files/.../MIDIPRO-DRAWING.pdf",
  // Leave drawingPdf as "" if no drawing is available yet.
  // =========================================================

  products: [
    {
      id: "basic_16d",
      name: "BASIC",
      holeSystem: "16D",
      thickness: 6,
      image: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/basic.png?v=1788953315",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC00709.jpg?v=1701790196",
      drawingPdf: "",
      basePrice: 449,
      workingAreas: ["520 x 520mm", "1000 x 600mm"],
      legs: null,
      feet: null,
      build: null,
      legColors: null
    },
    {
      id: "hobby_16d",
      name: "HOBBY",
      holeSystem: "16D",
      thickness: 6,
      image: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/wc-icon-hobby.png?v=1788967847",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02315.jpg?v=1788429563",
      drawingPdf: "",
      basePrice: 500,
      workingAreas: ["1200 x 600mm", "1200 x 800mm"],
      legs: ["No Legs", "Standard Legs"],
      feet: ["Adjustable Feet", "Standard Castors"],
      build: ["Self Weld Kit", "Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "midipro_16d",
      name: "MIDIPRO",
      holeSystem: "16D",
      thickness: 6,
      image: "midi-pro.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02315.jpg?v=1788429563",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/MidiPRO-SPECIFICATION-DRAWING-2026.pdf?v=1790635318",
      basePrice: 1245,
      workingAreas: [
        "1000 x 1000mm", "1250 x 750mm", "1250 x 1000mm", "1250 x 1250mm",
        "1500 x 750mm", "1500 x 1000mm", "1500 x 1250mm", "1500 x 1500mm",
        "1750 x 750mm", "1750 x 1000mm", "1750 x 1250mm", "1750 x 1500mm",
        "1800 x 900mm", "2000 x 1000mm"
      ],
      legs: ["No Legs", "Standard Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Self Weld Kit", "Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "pro6_16d",
      name: "PRO 6",
      holeSystem: "16D",
      thickness: 6,
      image: "pro10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02315.jpg?v=1788429563",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/PRO6-SPECIFICATION-DRAWING-2026.pdf?v=1790635323",
      basePrice: 1495,
      workingAreas: [
        "1000 x 1000mm", "1250 x 750mm", "1250 x 1000mm", "1250 x 1250mm",
        "1500 x 750mm", "1500 x 1000mm", "1500 x 1250mm", "1500 x 1500mm",
        "1750 x 750mm", "1750 x 1000mm", "1750 x 1250mm", "1750 x 1500mm",
        "1800 x 900mm", "2000 x 1000mm", "2000 x 1250mm", "2500 x 1000mm",
        "2500 x 1250mm", "2900 x 1400mm"
      ],
      legs: ["No Legs", "Standard Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Self Weld Kit", "Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "pro8_16d",
      name: "PRO 8",
      holeSystem: "16D",
      thickness: 8,
      image: "pro10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02315.jpg?v=1788429563",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/PRO8-SPECIFICATION-DRAWING-2026.pdf?v=1790635329",
      basePrice: 1595,
      workingAreas: [
        "1000 x 1000mm", "1250 x 750mm", "1250 x 1000mm", "1250 x 1250mm",
        "1500 x 750mm", "1500 x 1000mm", "1500 x 1250mm", "1500 x 1500mm",
        "1750 x 750mm", "1750 x 1000mm", "1750 x 1250mm", "1750 x 1500mm",
        "1800 x 900mm", "2000 x 1000mm", "2000 x 1250mm", "2500 x 1000mm",
        "2500 x 1250mm", "2900 x 1400mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Self Weld Kit", "Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "pro10_16d",
      name: "PRO 10",
      holeSystem: "16D",
      thickness: 10,
      image: "pro10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02315.jpg?v=1788429563",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/PRO10-SPECIFICATION-DRAWING-2026.pdf?v=1790635335",
      basePrice: 1795,
      workingAreas: [
        "1000 x 1000mm", "1250 x 750mm", "1250 x 1000mm", "1250 x 1250mm",
        "1500 x 750mm", "1500 x 1000mm", "1500 x 1250mm", "1500 x 1500mm",
        "1750 x 750mm", "1750 x 1000mm", "1750 x 1250mm", "1750 x 1500mm",
        "1800 x 900mm", "2000 x 1000mm", "2000 x 1250mm", "2500 x 1000mm",
        "2500 x 1250mm", "2900 x 1400mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Self Weld Kit", "Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "ultra10_16d",
      name: "ULTRA 10",
      holeSystem: "16D",
      thickness: 10,
      image: "ultra10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02012.jpg?v=1784301974",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/UL10-SPECIFICATION-DRAWING-2026.pdf?v=1790635340",
      basePrice: 2195,
      workingAreas: [
        "1400 x 1000mm", "1400 x 1400mm", "1800 x 1400mm",
        "2200 x 1400mm", "2800 x 1400mm", "3000 x 1500mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "ultra15_16d",
      name: "ULTRA 15",
      holeSystem: "16D",
      thickness: 15,
      image: "ultra10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/products/11.png?v=1681249772",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/UL15-SPECIFICATION-DRAWING-2026.pdf?v=1790635346",
      basePrice: 2495,
      workingAreas: [
        "1400 x 1000mm", "1400 x 1400mm", "1800 x 1400mm",
        "2200 x 1400mm", "2800 x 1450mm", "3000 x 1500mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "pro10_28d",
      name: "PRO 10",
      holeSystem: "28D",
      thickness: 10,
      image: "pro10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC02012.jpg?v=1784301974",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/PRO10-SPECIFICATION-DRAWING-2026.pdf?v=1790635335",
      basePrice: 1795,
      workingAreas: [
        "1000 x 1000mm", "1250 x 750mm", "1250 x 1000mm", "1250 x 1250mm",
        "1500 x 750mm", "1500 x 1000mm", "1500 x 1250mm", "1500 x 1500mm",
        "1750 x 750mm", "1750 x 1000mm", "1750 x 1250mm", "1750 x 1500mm",
        "1800 x 900mm", "2000 x 1000mm", "2000 x 1250mm", "2500 x 1000mm",
        "2500 x 1250mm", "2900 x 1400mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Self Weld Kit", "Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "ultra10_28d",
      name: "ULTRA 10",
      holeSystem: "28D",
      thickness: 10,
      image: "ultra10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/DSC00472.jpg?v=1696057661",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/UL10-SPECIFICATION-DRAWING-2026.pdf?v=1790635340",
      basePrice: 2195,
      workingAreas: [
        "1400 x 1000mm", "1400 x 1400mm", "1800 x 1400mm",
        "2200 x 1400mm", "2800 x 1400mm", "3000 x 1500mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    },
    {
      id: "ultra15_28d",
      name: "ULTRA 15",
      holeSystem: "28D",
      thickness: 15,
      image: "ultra10.png",
      previewImage: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/mac_ultra_10_weld_table.jpg?v=1714848123",
      drawingPdf: "https://cdn.shopify.com/s/files/1/0266/6161/7869/files/UL15-SPECIFICATION-DRAWING-2026.pdf?v=1790635346",
      basePrice: 2495,
      workingAreas: [
        "1400 x 1000mm", "1400 x 1400mm", "1800 x 1400mm",
        "2200 x 1400mm", "2800 x 1450mm", "3000 x 1500mm"
      ],
      legs: ["No Legs", "Standard Legs", "Height Adjustable Legs"],
      feet: ["Adjustable Feet", "FM Castors"],
      build: ["Ready Made by Mac"],
      legColors: ["Raw No Paint", "Red", "Green", "Blue", "Grey", "Black"]
    }
  ],

  // =========================================================
  // OPTIONAL PREVIEW IMAGE OVERRIDES — FOR FUTURE USE
  // =========================================================
  // Each product now has previewImage for the large image shown
  // in the Your Configuration panel.
  //
  // Later, if you want the large image to change with legs, feet,
  // build option or leg colour, add a previewImages object INSIDE
  // that product. Example:
  //
  // previewImages: {
  //   default: "pro10.png",
  //   legs: {
  //     "No Legs": "pro10-no-legs.png",
  //     "Standard Legs": "pro10-standard-legs.png",
  //     "Height Adjustable Legs": "pro10-height-adjustable-legs.png"
  //   },
  //   feet: {
  //     "Adjustable Feet": "pro10-adjustable-feet.png",
  //     "FM Castors": "pro10-castors.png"
  //   },
  //   build: {
  //     "Self Weld Kit": "pro10-self-weld.png",
  //     "Ready Made by Mac": "pro10-ready-made.png"
  //   },
  //   legColors: {
  //     "Black": "pro10-black.png"
  //   },
  //   combinations: {
  //     "Standard Legs|FM Castors|Ready Made by Mac|Black":
  //       "pro10-castors-ready-black.png"
  //   }
  // }
  // =========================================================

  variantPrices: {
    basic_16d: {
      "520 x 520mm": 180,
      "1000 x 600mm": 280
    },
    hobby_16d: {
      "1200 x 600mm": 290,
      "1200 x 800mm": 350
    },
    midipro_16d: {
      "1000 x 1000mm": 601.28,
      "1250 x 750mm": 581.55,
      "1250 x 1000mm": 684.65,
      "1250 x 1250mm": 787.75,
      "1500 x 750mm": 645.19,
      "1500 x 1000mm": 718.02,
      "1500 x 1250mm": 840.85,
      "1500 x 1500mm": 963.68,
      "1750 x 750mm": 658.83,
      "1750 x 1000mm": 801.39,
      "1750 x 1250mm": 943.95,
      "1750 x 1500mm": 1086.51,
      "1800 x 900mm": 801.39,
      "2000 x 1000mm": 885.76
    },
    pro6_16d: {
      "1000 x 1000mm": 859.85,
      "1250 x 750mm": 832.20,
      "1250 x 1000mm": 978.85,
      "1250 x 1250mm": 1125.50,
      "1500 x 750mm": 923.57,
      "1500 x 1000mm": 1097.86,
      "1500 x 1250mm": 1272.15,
      "1500 x 1500mm": 1446.44,
      "1750 x 750mm": 1014.94,
      "1750 x 1000mm": 1216.87,
      "1750 x 1250mm": 1418.80,
      "1750 x 1500mm": 1620.73,
      "1800 x 900mm": 1116.87,
      "2000 x 1000mm": 1285.88,
      "2000 x 1250mm": 1515.45,
      "2500 x 1000mm": 1523.90,
      "2500 x 1250mm": 1808.75,
      "2900 x 1400mm": 1842.18
    },
    pro8_16d: {
      "1000 x 1000mm": 926.75,
      "1250 x 750mm": 894.90,
      "1250 x 1000mm": 1062.45,
      "1250 x 1250mm": 1230,
      "1500 x 750mm": 998.81,
      "1500 x 1000mm": 1198.18,
      "1500 x 1250mm": 1397.55,
      "1500 x 1500mm": 1596.92,
      "1750 x 750mm": 1102.72,
      "1750 x 1000mm": 1333.91,
      "1750 x 1250mm": 1565.10,
      "1750 x 1500mm": 1796.23,
      "1800 x 900mm": 1233.91,
      "2000 x 1000mm": 1369.64,
      "2000 x 1250mm": 1632.65,
      "2500 x 1000mm": 1641.10,
      "2500 x 1250mm": 1967.75,
      "2900 x 1400mm": 2143.14,
    },
    pro10_16d: {
      "1000 x 1000mm": 1025.36,
      "1250 x 750mm": 984.25,
      "1250 x 1000mm": 1198.25,
      "1250 x 1250mm": 1412.25,
      "1500 x 750mm": 1116.03,
      "1500 x 1000mm": 1271.14,
      "1500 x 1250mm": 1526.25,
      "1500 x 1500mm": 1781.36,
      "1750 x 750mm": 1147.81,
      "1750 x 1000mm": 1444.03,
      "1750 x 1250mm": 1740.25,
      "1750 x 1500mm": 2036.47,
      "1800 x 900mm":  1444.03,
      "2000 x 1000mm": 1616.92,
      "2000 x 1250mm": 1954.25,
      "2500 x 1000mm": 1962.70,
      "2500 x 1250mm": 2382.25,
      "2900 x 1400mm": 2862.02
    },
    ultra10_16d: {
      "1400 x 1000mm": 1695.66,
      "1400 x 1400mm": 1758.25,
      "1800 x 1400mm": 2422.85,
      "2200 x 1400mm": 2504.79,
      "2800 x 1400mm": 2944.21,
      "3000 x 1500mm": 3044.21
    },
    ultra15_16d: {
      "1400 x 1000mm": 2182.38,
      "1400 x 1400mm": 2698.95,
      "1800 x 1400mm": 2832.65,
      "2200 x 1400mm": 3134.84,
      "2800 x 1450mm": 3260.70,
      "3000 x 1500mm": 3585.70
    },
    pro10_28d: {
     "1000 x 1000mm": 1025.36,
      "1250 x 750mm": 984.25,
      "1250 x 1000mm": 1198.25,
      "1250 x 1250mm": 1412.25,
      "1500 x 750mm": 1116.03,
      "1500 x 1000mm": 1271.14,
      "1500 x 1250mm": 1526.25,
      "1500 x 1500mm": 1781.36,
      "1750 x 750mm": 1147.81,
      "1750 x 1000mm": 1444.03,
      "1750 x 1250mm": 1740.25,
      "1750 x 1500mm": 2036.47,
      "1800 x 900mm":  1444.03,
      "2000 x 1000mm": 1616.92,
      "2000 x 1250mm": 1954.25,
      "2500 x 1000mm": 1962.70,
      "2500 x 1250mm": 2382.25,
      "2900 x 1400mm": 2862.02
    },
    ultra10_28d: {
      "1400 x 1000mm": 1695.66,
      "1400 x 1400mm": 1758.25,
      "1800 x 1400mm": 2422.85,
      "2200 x 1400mm": 2504.79,
      "2800 x 1400mm": 2944.21,
      "3000 x 1500mm": 3044.21
    },
    ultra15_28d: {
        "1400 x 1000mm": 2182.38,
      "1400 x 1400mm": 2698.95,
      "1800 x 1400mm": 2832.65,
      "2200 x 1400mm": 3134.84,
      "2800 x 1450mm": 3260.70,
      "3000 x 1500mm": 3585.70
    }
  },


  // =========================================================
  // READY MADE BY MAC — LABOUR PRICE BY TABLE SIZE
  // =========================================================
  // These prices are added ONLY when "Ready Made by Mac" is selected.
  // Self Weld Kit adds £0 labour.
  //
  // Edit the figures below whenever your labour rates change.
  // The same size price is used across product ranges by default.
  // If a particular product needs a different labour charge, add it
  // under byProduct using the product ID and size.
  // =========================================================

  readyMadePrices: {
    defaultBySize: {
      "520 x 520mm": 150,
      "1000 x 600mm": 150,
      "1000 x 1000mm": 150,
      "1200 x 600mm": 150,
      "1200 x 800mm": 150,
      "1250 x 750mm": 150,
      "1250 x 1000mm": 150,
      "1250 x 1250mm": 200,
      "1400 x 1000mm": 200,
      "1400 x 1400mm": 200,
      "1800 x 1400mm": 200,
      "1500 x 750mm": 200,
      "1500 x 1000mm": 200,
      "1500 x 1250mm": 200,
      "1500 x 1500mm": 200,
      "1750 x 750mm": 200,
      "1750 x 1000mm": 300,
      "1750 x 1250mm": 300,
      "1750 x 1500mm": 300,
      "1800 x 900mm": 300,
      "2000 x 1000mm": 300,
      "2000 x 1250mm": 350,
      "2200 x 1400mm": 350,
      "2500 x 1000mm": 350,
      "2500 x 1250mm": 350,
      "2800 x 1400mm": 450,
      "2800 x 1450mm": 450,
      "2900 x 1400mm": 450,
      "3000 x 1500mm": 450
    },

    // Optional product-specific overrides.
    // Example:
    // byProduct: {
    //   ultra10_16d: {
    //     "3000 x 1500mm": 500
    //   }
    // }
    byProduct: {}
  },

  priceModifiers: {
    holeSystem: {
      "16D": 0,
      "28D": 0
    },
    thickness: {
      6: 0,
      8: 0,
      10: 0,
      15: 0
    },
    sizes: {
      "520 x 520mm": 10,
      "1000 x 600mm": 25,
      "1000 x 1000mm": 400,
      "1200 x 600mm": 0,
      "1200 x 800mm": 100,
      "1250 x 750mm": 40,
      "1250 x 1000mm": 50,
      "1250 x 1250mm": 60,
      "1400 x 1000mm": 55,
      "1400 x 1400mm": 80,
      "1800 x 1400mm": 100,
      "1500 x 750mm": 45,
      "1500 x 1000mm": 60,
      "1500 x 1250mm": 75,
      "1500 x 1500mm": 90,
      "1750 x 750mm": 50,
      "1750 x 1000mm": 70,
      "1750 x 1250mm": 90,
      "1750 x 1500mm": 105,
      "1800 x 900mm": 65,
      "2000 x 1000mm": 80,
      "2000 x 1250mm": 100,
      "2200 x 1400mm": 125,
      "2500 x 1000mm": 100,
      "2500 x 1250mm": 125,
      "2800 x 1400mm": 155,
      "2800 x 1450mm": 155,
      "2900 x 1400mm": 170,
      "3000 x 1500mm": 180
    },

    // Price PER individual leg
    legs: {
      "No Legs": 0,
      "Standard Legs": 25,
      "Height Adjustable Legs": 165
    },

    feet: {
      "Adjustable Feet": 45,
      "FM Castors": 20,
      // HOBBY-only castor. Change this figure to the correct price if different.
      "Standard Castors": 20
    },

    build: {
      "Self Weld Kit": 0,
      "Ready Made by Mac": 450
    },

    legColors: {
      "Raw No Paint": 0,
      "Red": 60,
      "Green": 60,
      "Blue": 60,
      "Grey": 60,
      "Black": 60
    }
  },

  // VAT
  // All configurator prices above are EX VAT.
  // The engine uses this rate to show the inclusive total as well.
  vatRate: 0.20,

  currency: "£"
};
